import { render } from "./EditSalesPerson.vue?vue&type=template&id=1a41fd5e"
import script from "./EditSalesPerson.vue?vue&type=script&lang=js"
export * from "./EditSalesPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__